import React from 'react';
import DocumentosVersionadosPage from "../../components/documentos/DocumentosVersionadosPage";
import AdicionarContratoPlano from "./components/AdicionarContratoPlano";

function ContratoPlano() {
    return (
        <DocumentosVersionadosPage
            title="Contrato de Plano"
            subtitle="Histórico de versões do contrato de prestação de serviços dos planos."
            listEndpoint="listarContratosPlano"
            responseKey="contratosPlanos"
            getId={(contrato) => contrato?.idContratoPlano}
            addLabel="Nova versão"
            emptyMessage="Nenhum contrato de plano encontrado."
            renderAddDialog={({ open, onClose }) => (
                <AdicionarContratoPlano adicionarContrato={open} setAdicionarContrato={(value) => !value && onClose()} />
            )}
        />
    );
}

export default ContratoPlano;
